export const updateEmailModal = {
  'update_email_modal.title': 'Úprava e-mailové adresy',
  'update_email_modal.subtitle':
    'Po úpravě vám zašleme odhad ceny na nově zadanou e-mailovou adresu.',
  'update_email_modal.input.label': 'E-mail',
  'update_email_modal.input.placeholder': 'jarda@jarda.cz',
  'update_email_modal.input.button': 'Zaslat odhad na nový e-mail',
  'update_email_modal.error':
    'E-mail se nepodařilo upravit. Zkuste to prosím znovu později.',
};
